import http from '~/http/index';

export default ({
  state: {
    data: {},
  },

  getters: {
  },

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    async loadData({ commit }) {
      const response = await http.get('Options/GetUploadOptions');
      commit('SET_DATA', response.data);
    },

    async updateOptions(__store, data) {
      const response = await http.post('Options/UpdateUploadOptions', data);
      return response.data;
    },
  },

  namespaced: true,
});
